export const salePipelineStages = [
    { id: 1, name: "Escolhendo a Origem" },
    { id: 2, name: "Escolhendo o Destino" },
    { id: 3, name: "Escolhendo a Data da Viagem" },
    { id: 4, name: "Escolhendo o Horário da Viagem" },
    { id: 5, name: "Sem Resultado para Origem/Destino/Data" },
    { id: 6, name: "Escolhendo o Assento" },
    { id: 7, name: "Sem Assentos Disponíveis" },
    { id: 8, name: "Informando Dados dos Passageiros" },
    { id: 9, name: "Aguardando Pagamento" },
    { id: 10, name: "Pagamento Não Confirmado" },
    { id: 11, name: "Pagamento Confirmado" },
    { id: 12, name: "Ticket Emitido" },
    { id: 13, name: "Venda Concluída" },
    { id: 14, name: "Erro na Emissão do Ticket" },
    { id: 15, name: "Venda Cancelada" },
    { id: 16, name: "Chargeback" },
];